// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1fhkE","content":"styles_content__2WhUB","imagen":"styles_imagen__-HzOg"};